import BodySimpleModalV3 from "../../../common/modal/BodySimpleModalV3";
import Button from "../../../common/Button";
import { exportGDQReport } from "../../../../lib/fetchApi";
import { useDispatch, useSelector } from "react-redux";
import { notificationActions } from "../../../../store/notifications";
import { useState } from "react";
import ReactDOM from "react-dom";
import Backdrop from "../../../common/modal/Backdrop";
import Modal from "../../../common/Modal";
import ModalInnerWrapper from "../../../common/ModalInnerWrapper";
import PannelBody from "../../../fragments/PannelBody";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import { formatDate } from "../../../../lib/script";
import classes from './GDQReportExport.module.css'
import "@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css";
import "react-calendar/dist/Calendar.css";
export default function GDQReportExport() {

    const userToken = useSelector(state => state.user.token)
    const dispatch = useDispatch()
    const today = new Date()
    // Default GDQ report date range: last week (last 7 days ending today).
    const lastWeekStart = new Date(today)
    lastWeekStart.setDate(lastWeekStart.getDate() - 7)
    lastWeekStart.setHours(0, 0, 0, 0)
    const lastWeekEnd = new Date(today)
    lastWeekEnd.setHours(23, 59, 59, 999)

    const [loading, setLoading] = useState(false)
    const [showModal, setShowModal] = useState(null)
    const [showDateRangeModal, setShowDateRangeModal] = useState(false)
    const [dateRange, setDateRange] = useState([lastWeekStart, lastWeekEnd])

    function openDateRangeModalHandler() {
        setShowDateRangeModal(true)
    }

    function closeDateRangeModalHandler() {
        setShowDateRangeModal(false)
    }

    function handleDateRangeChange(nextValue) {
        setDateRange(nextValue || null)
    }

    async function exportHandler() {
        let fromDate = null
        let toDate = null
        if (Array.isArray(dateRange)) {
            fromDate = dateRange[0] || null
            // Allow a single-day report: if only one date is chosen, use it for both ends.
            toDate = dateRange[1] || dateRange[0] || null
        } else if (dateRange instanceof Date) {
            fromDate = dateRange
            toDate = dateRange
        }

        if (!fromDate || !toDate) {
            dispatch(notificationActions.setError({ errorMessage: 'Please select a date or date range.' }))
            return
        }

        if (new Date(fromDate) > new Date(toDate)) {
            dispatch(notificationActions.setError({ errorMessage: 'From date cannot be greater than to date.' }))
            return
        }

        setLoading(true)
        let response = await exportGDQReport(userToken, { from: formatDate(fromDate), to: formatDate(toDate) })

        console.log('response', response)
        if (response && response.errorMessage) {
        
            dispatch(notificationActions.setError(response))
        } else {            
            const formatForFileName = (date) => {
                const d = new Date(date)
                const mm = String(d.getMonth() + 1).padStart(2, '0')
                const dd = String(d.getDate()).padStart(2, '0')
                const yyyy = d.getFullYear()
                return `${mm}${dd}${yyyy}`
            }
            const fileURL = URL.createObjectURL(response)
            const a = document.createElement("a");
            a.href = fileURL;
            a.download = `gdq_report_${formatForFileName(fromDate)}_${formatForFileName(toDate)}.csv`;
            a.click();
            URL.revokeObjectURL(fileURL);
            setShowDateRangeModal(false)
        }
        setLoading(false)
    }

    function closeModalHandler() {
        setShowModal(null)
    }

    function copyHandler() {
        const rows = document.querySelectorAll("#myTable tr");
        let result = "Pending Discharge\tReview Pending\n";

        rows.forEach((row, index) => {
        if (index === 0) return; // skip header

        const cells = row.querySelectorAll("td");
        const pendingDischarge = cells[1].innerText;
        const reviewPending = cells[2].innerText;

        result += `${pendingDischarge}\t${reviewPending}\n`;
        });

        navigator.clipboard.writeText(result);
        // navigator.clipboard.writeText(JSON.stringify(showModal))
        dispatch(notificationActions.setError({errorMessage: `GDQ Report data copied to clipboard`, type: 'success'}))
    }

    return <>
    
        <BodySimpleModalV3 message={'GDQ Report'}>
            <Button click={openDateRangeModalHandler} isLoading={loading}>
                <i className="ti ti-file-arrow-right"></i>
            </Button>
        </BodySimpleModalV3>

        {(showModal || showDateRangeModal) && <>
            {ReactDOM.createPortal(
                <Backdrop hide={showDateRangeModal ? closeDateRangeModalHandler : closeModalHandler} />,
                document.getElementById("backdrop-root")
            )}  
        </>}

        {showDateRangeModal && <>
            {ReactDOM.createPortal(
                <Modal>
                    <ModalInnerWrapper modalTitle={'GDQ Report Date Range'} closeModal={closeDateRangeModalHandler} widthAuto={true} noOverflow={true}>
                        <PannelBody>
                            <div className={classes.date_range_wrapper}>
                                <div className={classes.field_row}>
                                    <label htmlFor="gdq-date-range">Date Range</label>
                                    <DateRangePicker
                                        id="gdq-date-range"
                                        value={dateRange}
                                        onChange={handleDateRangeChange}
                                        maxDate={today}
                                        clearIcon={null}
                                        calendarAriaLabel="Toggle date range calendar"
                                    />
                                </div>
                            </div>
                        </PannelBody>

                        <PannelBody>
                            <Button click={exportHandler} isLoading={loading}>Generate Report</Button>
                        </PannelBody>
                    </ModalInnerWrapper>
                </Modal>,
                document.getElementById("overlay-root")
            )}
        </>}

        {showModal && <>
            {ReactDOM.createPortal(
                <Modal>
                    <ModalInnerWrapper modalTitle={'GDQ Report'} closeModal={closeModalHandler} widthAuto={true}>                        
                        <PannelBody>
                            <div className={classes.table_container}>
                                <table id="myTable">
                                    <thead>
                                        <tr>
                                            <th>Clinic</th>
                                            <th>Pending Discharge</th>
                                            <th>Review Pending</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {showModal.map(item => (
                                            <tr key={item.location_id}>
                                                <td>{item.location}</td>
                                                <td>{item.pending_discharge_count}</td>
                                                <td>{item.review_pending_count}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </PannelBody>

                        <PannelBody>
                            <Button click={copyHandler} isLoading={loading}>Copy</Button>
                        </PannelBody>
                    </ModalInnerWrapper>
                    
                </Modal>,
                document.getElementById("overlay-root")
            )}                  
        </>}
    </>
}